<template>
  <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_48352_215801)">
      <path d="M35.9062 71.6264V47.6746C35.9062 46.7057 36.2911 45.7765 36.9762 45.0914C37.6613 44.4064 38.5905 44.0215 39.5593 44.0215H55.0849L65.1309 54.0674V71.6264" stroke="#A8B6D8" stroke-width="5.57143" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M56.4142 64.1152H44.584" stroke="#A8B6D8" stroke-width="5.57143" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M49.6925 55.4473H44.584" stroke="#A8B6D8" stroke-width="5.57143" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M74.7397 67.3629V39.3606C74.7397 36.6961 72.5596 34.516 69.895 34.516H50.7101C49.3052 34.516 47.9487 33.8862 47.0282 32.8203L44.8965 30.3011C43.976 29.2353 42.6195 28.6055 41.2146 28.6055H31.1376C28.4731 28.6055 26.293 30.7856 26.293 33.4501V67.3629C26.293 70.0274 28.4731 72.2075 31.1376 72.2075H69.895C72.5596 72.2075 74.7397 70.0274 74.7397 67.3629Z" stroke="#A8B6D8" stroke-width="5.57143" />
    </g>
    <defs>
      <clipPath id="clip0_48352_215801">
        <rect x="0.515625" y="0.40625" width="100" height="100" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
